'use strict';

module.exports = 1000;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/INTERNAL_MEMOIZE_LIMIT.js
// module id = 461
// module chunks = 0